<template>
  <div class="actions-container">
    <table width="100%">
      <tr>
        <td>
          <h3 class="video-actions-title">Actions</h3>
        </td>
        <td class="switch-buttons">
          <v-switch
            label="Button Text"
            value
            input-value="true"
            color="primary"
            class="switch-input"
            v-model="toogleNames"
          ></v-switch>
        </td>
        <td class="switch-buttons">
          <v-switch
            label="Keyboard Shortcuts"
            value
            input-value="true"
            class="switch-input"
            color="primary"
            v-model="toogleKeys"
          ></v-switch>
        </td>
      </tr>
    </table>

    <center>
      <table height="100%" width="1000">
        <tr>
          <td v-for="action in actions" :key="action.name" style="padding: 0px 5px 0px 5px">
            <v-card class="action-cards" @click="pressButton(action.panel, action.method)">
              <v-card-text class="primary panel-name-letters white--text"><span v-show="toogleKeys">{{action.key}}</span></v-card-text>
              <v-layout align-center justify-space-around>
                <v-icon medium center class="action-icon">{{action.icon}}</v-icon>
              </v-layout>
              <v-card-text v-show="toogleNames" class="primary action-name white--text">{{action.name}}</v-card-text>
            </v-card>
          </td>
        </tr>
      </table>
    </center>
  </div>
</template>

<script>
import {mapState} from "vuex";
export default {
  data() {
    return {
      actions: [
        { key: "I", icon: "icons8-stopwatch", name: "MARK IN", method: "markIn", panel: false },
        { key: "O", icon: "icons8-finish-flag", name: "MARK OUT", method: "markOut", panel: false },
        { key: "M", icon: "icons8-south", name: "SAVE CLIP", method: "saveClip", panel: false },
        { key: "P", icon: "icons8-play", name: "PLAY CLIP", method: "playClip", panel: false },
        { key: "DEL", icon: "icons8-paper-bin", name: "DELETE CLIP", method: "deleteClip", panel: false },
        { key: "J", icon: "icons8-walking", name: "SHUTTLE BACK", method: "shuttleBack", panel: false },
        { key: "L", icon: "icons8-running", name: "SHUTTLE FWD", method: "shuttleFwd", panel: false },
        { key: "F", icon: "icons8-full-screen", name: "FULL SCREEN", method: "fullScreen", panel: false },
        {
          key: "SPACE",
          icon: "icons8-play-button-circled",
          name: "PLAY VIDEO",
          method: "playVideo"
        },
        { key: "UP", icon: "icons8-arrow", name: "PANEL UP", method: "panelUp", panel: true },
        { key: "DOWN", icon: "icons8-drop-down-arrow", name: "PANEL DOWN", method: "panelDown", panel: true },
        { key: "LEFT", icon: "icons8-sort-left", name: "STEP BACK", method: "stepBack", panel: false },
        { key: "RIGHT", icon: "icons8-sort-right", name: "STEP FWD", method: "stepFwd", panel: false }
      ],
      toogleNames: true,
      toogleKeys: true
    };
  },
  computed:{
    ...mapState({
      clip: state => state.clip,
      actionsBtns: state => state.actionsBtns.btnPressed,
      actionsBtnsPanels: state => state.actionsBtnsPanels.btnPressed
    })
  },
  watch: {
    
  },
  methods: {
    pressButton(panel, action){
      if( panel === true){
        this.$store.commit("actionsBtnsPanels/setButtonEmpty");
        this.$store.commit('actionsBtnsPanels/setButtonPressed', action);
      }else{
        this.$store.commit("actionsBtns/setButtonEmpty");
        this.$store.commit('actionsBtns/setButtonPressed', action);
      }
    }
  }
};
</script>

<style>
.actions-container {
  margin: 0 !important;
  padding-bottom: 0px !important;
  max-width: 100% !important;
}

.actions {
  flex-basis: 7.6% !important;
}


.action-icon {
  padding-top: 7% !important;
  padding-bottom: 7% !important;
  text-align: center !important;
}

.action-name {
  padding: 0 !important;
  text-align: center;
  font-size: 8px;
  height: 13px !important;
  position: absolute;
  bottom: 0 !important;
}

.switch-input {
  margin-top: 0 !important;
  font-size: 12px !important;
}

.switch-input .v-label {
  font-size: 14px !important;
}
 
.video-actions-title {
  text-align: left !important;
  padding-left: 2%;
}

.switch-buttons {
  float: right !important;
  padding-right: 2% !important;
}

.action-cards{
  width: 80px !important;
  height: 80px !important;
}

@media only screen and (max-width: 1210px) {
.action-cards{
  width: 65px !important;
  height: 65px !important;
}
}
</style>
